import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { size as _size } from 'lodash';
import { i18nIntl, formatNumber, isDesktop, isNotEmpty } from '../../../lib/ep.js';

import { SquaredButton } from '../../builder/ActionButton';
import ButtonCollection from '../../builder/ButtonCollection';
import Tooltip from '../../builder/Tooltip';

import FloatingLayerPublic from '../FloatingLayerPublic.js';
import QuizStatsPublic from '../../front/quiz/QuizStatsPublic';
import LeveledHTMLText from '../helpers/LeveledHTMLText.js';

import { UserTeamParticipationDetail } from '../../../containers/TeamClient.js';
import { stage_promotion_types } from '../../../data/bootstrap_stages.js';
import { GuessScoreResumeWithPoints } from '../GuessScoreResume.js';
import PickFavoriteFinal from '../PickFavoriteFinal.js';
import OneTimeBracketFinal, { OneTimeBracketFinalWithPoints } from '../OneTimeBracketFinal.js';

const SpanItem = (props) => {
	return <span class={props._class}>{props.children}</span>
};

const StrongItem = (props) => {
	return <strong class={props._class}>{props.children}</strong>
};

const ParticipationRow = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const [ display_team_details, setDisplayTeamDetails ] = useState(false);
	const [ display_guess_score_details, setDisplayGuessScoreDetails ] = useState(false);
	const [ display_pick_favorite_details, setDisplayPickFavoriteDetails ] = useState(false);

	let display_date = props.display_date;
	let has_ranking_enabled = props.has_ranking_enabled;
	let stage = props.stage;
	if(!stage)return null;
	let stageScore = props.stageScore;
	let actions = props.actions;

	const tzcreated = moment.tz(stageScore.created, 'Europe/Madrid').tz(props.tz);

	const is_selected = (props.is_selected != undefined) ? props.is_selected : false;
	const second_level = (props.second_level != undefined) ? props.second_level : false;
	const force_counter = (props.force_counter != undefined) ? props.force_counter : false;

	let tr_class = [];
	if(is_selected) tr_class.push('is_selected');
	if(second_level) tr_class.push('second_level');

	const is_team = stage?.is_team ?? false;
	const is_guess_score = ([stage_promotion_types.SCORE_PREDICTOR.id].includes(parseInt(stage.promotion_type_id))) ? true : false;
	const is_pick_favorite = ([stage_promotion_types.PICK_FAVORITE.id].includes(parseInt(stage.promotion_type_id))) ? true : false;
	const is_bracket_predictor = ([stage_promotion_types.BRACKET_PREDICTOR.id].includes(parseInt(stage.promotion_type_id))) ? true : false;
	const Item = (!second_level) ? StrongItem : SpanItem;

	const used_stage = props.stages.find((s) => ((stageScore?.stage_id ?? stageScore.stage) == s.Stage.id));

	return (
		<tr class={(tr_class.length > 0) ? tr_class.join(" ") : null}>
			<td class="ranking_pos" style={{ width:'12%' }}>
				{(!second_level || force_counter) && (
					<span>#{props.row_index}</span>
				)}
			</td>

			{(!second_level) && (
				<td class="gui_text_align_start">
					<div class="sided_contents">
						{(stage.icon != undefined) && (
							<Tooltip position="top" icon={stage.icon}>{is_selected} - {stage.stage_type}</Tooltip>
						)}

						<div class="title is_multilined">
							<Item _class="gui_cutTextOnOverflow">
								{(stage.display_title != undefined && stage.display_title != "") ? stage.display_title : i18n("Stage") + ((stage.order != undefined) ? " #" + stage.order : "")}
							</Item>
						</div>
					</div>
				</td>
			)}

			{(display_date || second_level) && (
				<td class="gui_text_align_start">{tzcreated.format(((!isDesktop()) ? 'L, LT' : 'LL, LT'))}</td>
			)}

			{(has_ranking_enabled) && (
				<td class="gui_text_align_end" style={{ width:'10%' }}>
					{(true) && (
						<span class="gui_flexbox_auto gui_flex_end gui_flex_align_center">
							<Item>{formatNumber((stageScore.score != undefined) ? stageScore.score : stageScore.quiz_result)}</Item>
						</span>
					)}
				</td>
			)}

			<td class="row_actions" style={{ width:'12%' }}>
				{(actions.show_extra != undefined || (is_team && second_level)) && (
					<ButtonCollection _class={{other:'gui_flex_end'}}>
						{(!second_level && !is_selected) && (
							<SquaredButton
								onClick={actions.show_extra}
								color={false}
								icon={(!second_level) ? 'knk-visible' : 'knk-arrow-b-big'}
								aria-label="View extra"
							/>
						)}

						{(!second_level && is_selected) && (
							<SquaredButton
								onClick={actions.hide_extra}
								color={false}
								icon={(!second_level) ? 'knk-drop' : 'knk-arrow-t-big'}
								aria-label="Hide extra"
							/>
						)}

						{(is_team && second_level) && (
							<SquaredButton
								onClick={() => setDisplayTeamDetails(true)}
								color={false}
								icon='knk-visible'
								aria-label="View details"
							/>
						)}
						{((is_guess_score || is_bracket_predictor) && second_level) && (
							<SquaredButton
								onClick={() => setDisplayGuessScoreDetails(true)}
								color={false}
								icon='knk-visible'
								aria-label="View details"
							/>
						)}
						{(is_pick_favorite && second_level) && (
							<SquaredButton
								onClick={() => setDisplayPickFavoriteDetails(true)}
								color={false}
								icon='knk-visible'
								aria-label="View details"
							/>
						)}
					
					</ButtonCollection>
				)}

				{(display_team_details) && (
					<FloatingLayerPublic
						pm={props.promotion}
						title={`<h1>${props.intl.formatMessage({ id:"The team of {name}" }, { name:props.user_name })}</h1>`}
						backButton={() => setDisplayTeamDetails(false)}
					>
						<div class="in_user_list">
							<UserTeamParticipationDetail
								//{...stage}
								{...stageScore.quiz_entry}
								promotion={props.promotion}
								stage={used_stage?.Stage ?? null}
								user_id={stageScore.id}
								locale={stageScore.keyword}
								layer_title="Share this team"
								intl={props.intl}
							/>
						</div>
					</FloatingLayerPublic>
				)}

				{(display_guess_score_details) && (
					<FloatingLayerPublic
						pm={props.promotion}
						title={`<h1>${props.intl.formatMessage({ id:"The prediction of {name}" }, { name:props.user_name })}</h1>`}
						backButton={() => setDisplayGuessScoreDetails(false)}
					>
						<div class="in_user_list gui_game_wrapper">
							{(is_guess_score) && (
								<GuessScoreResumeWithPoints
									created={stageScore.created}
									promotion={props.promotion}
									stage={used_stage?.Stage ?? null}
									teams={props.promotion.guess_score_teams}
									results={used_stage?.Stage?.guess_score_matches_result ?? {}}
									answers={stageScore.quiz_entry.guess_score}
									user_id={stageScore.id}
									locale={stageScore.keyword}
									intl={props.intl}
								/>
							)}
							{(is_bracket_predictor) && (
								<OneTimeBracketFinalWithPoints
									user={stageScore}
									created={stageScore.created}
									promotion={props.promotion}
									stage={used_stage?.Stage ?? null}
									teams={props.promotion.guess_score_teams}
									results={used_stage?.Stage?.guess_score_matches_result ?? {}}
									answers={stageScore.quiz_entry.guess_score}
									user_id={stageScore.id}
									locale={stageScore.keyword}
									intl={props.intl}
									is_standalone={true}
									only_contents={true}
								/>
							)}
						</div>
					</FloatingLayerPublic>
				)}

				{(display_pick_favorite_details) && (
					<FloatingLayerPublic
						pm={props.promotion}
						title={`<h1>${props.intl.formatMessage({ id:"The choice of {name}" }, { name:props.user_name })}</h1>`}
						backButton={() => setDisplayPickFavoriteDetails(false)}
					>	
						<section class="gui_quiz_public_stats" style={{ marginBottom:'2em' }}>
							<div class="in_user_list">
								<PickFavoriteFinal
									in_ranking={true}
									user={stageScore}
									user_answer={stageScore.quiz_entry}
									promotion={props.promotion}
									stage={{
										...(used_stage?.Stage ?? {}),
										final_message:" ",
										faceoff_display_stats:false,
										likedislike_display_stats:false
									}}
									locale={stageScore.keyword}
									intl={props.intl}
								/>
							</div>
							
							{(isNotEmpty(stageScore, 'quiz_result')) && (
								<div class="gui_flexbox_auto gui_flex_center">
									{i18n("Score")}: <strong class="gui_not_in_start_micro">{stageScore.quiz_result} {i18n("points")}</strong>
								</div>
							)}
						</section>
					</FloatingLayerPublic>
				)}
			</td>
		</tr>
	)
};

const UserParticipationsUnifiedList = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [display_stage_participations, setDisplayStageParticipations] = useState(false);
	const [display_participation_details, setDisplayParticipationDetails] = useState(false);

	const display_total = (props.display_total != undefined) ? props.display_total : true;
	const display_complete_info = (props.display_complete_info != undefined) ? props.display_complete_info : false;
	const promotion = (props.promotion != undefined) ? props.promotion : false;

	const has_game_stages = (props.has_game_stages != undefined) ? props.has_game_stages : false;
	const has_quiz_stages = (props.has_quiz_stages != undefined) ? props.has_quiz_stages : false;

	const participations = (props.stage_participations != undefined) ? props.stage_participations : { summary:[], total:0 };
	const tz = promotion.timezone;

	const display_date = (props.display_date != undefined) ? props.display_date : false;
	const has_ranking_enabled = (promotion && promotion.public_entries != '0') ? true : false;

	let total_cols = 2;
	if(display_date) total_cols++;
	if(has_ranking_enabled) total_cols++;
	if(has_game_stages || has_quiz_stages) total_cols++;

	return (
		<LeveledHTMLText
			_class={{ other:'gui_participations_list' }}
		>
			{(participations.total != undefined && display_total) && (
				<div>{i18n("Total points")}: {formatNumber(participations.total)}</div>
			)}

			<table class={'single_user_participations' + ((display_total) ? ' gui_not_in_top_big' : '')} cellSpacing="0" cellPadding="0" style={{width:'100%'}}>
				<thead>
					<tr>
						<th class="hb_secondaryFont" style={{ width:'12%' }} />

						{(participations.summary.length > 1) && (
							<th class="gui_text_align_start hb_secondaryFont">{i18n("Stage")}</th>
						)}

						{(display_date || participations.summary.length == 1) && (
							<th class="gui_text_align_start hb_secondaryFont">{i18n("Date")}</th>
						)}

						{(has_ranking_enabled) && (
							<th class="gui_text_align_end hb_secondaryFont" style={{ width:'10%' }}>{i18n("score", 'ucfirst')}</th>
						)}

						<th class="hb_secondaryFont" style={{ width:'12%' }} />
					</tr>
				</thead>

				<tbody>
					{(participations.summary).map((part, i) => {
						const counter = _size(participations.summary) - i;

						let row_props = {
							display_date:display_date,
							intl:props.intl,
							has_game_stages:has_game_stages,
							has_quiz_stages:has_quiz_stages,
							has_ranking_enabled:has_ranking_enabled,
							stage:part.Stage,
							promotion:promotion,
							tz:tz,
							stages:props.stages,
							user_name:props?.user_name ?? null,
						};

						let row_index = (_size(participations.summary) > 10 && counter < 10) ? `0${counter}` : counter;
						let actions = {
							show_extra:() => {
								setDisplayStageParticipations(part.Participations[0].User.stage);
								setDisplayParticipationDetails(0);
							},
							hide_extra:() => {
								setDisplayStageParticipations(false);
								setDisplayParticipationDetails(false);
							},
						};
						if((display_stage_participations !== false && part?.Participations?.[0] != undefined && display_stage_participations == part?.Participations?.[0]?.User?.stage) || participations.summary.length == 1) {
							return (
								<tr key={`stage_${i}`}>
									<td colSpan={total_cols} style={{padding:'0'}}>
										{(participations.summary.length > 1) && (
											<table cellSpacing="0" cellPadding="0" style={{width:'100%'}}>
												<tbody>
													<ParticipationRow
														key={`stage_${i}`}
														{...row_props}
														actions={actions}
														row_index={row_index}
														stageScore={part.StageScore}
														is_selected={true}
													/>
												</tbody>
											</table>
										)}

										{part.Participations.map((participation, j) => {
											let p_actions = {};
											let has_extra = (participation.User.quiz_entry != undefined) ? true : false;
											if(has_extra) {
												p_actions = {
													show_extra:() => setDisplayParticipationDetails(j),
													hide_extra:() => setDisplayParticipationDetails(false),
												};
											}

											const p_counter = _size(part.Participations) - j;

											let p_row_index = (_size(part.Participations) > 10 && p_counter < 10) ? `0${p_counter}` : p_counter;

											let is_selected = (has_extra && display_participation_details === j) ? true : false;
											const is_team = part.Stage?.is_team ?? false;
											const is_guess_score = ([stage_promotion_types.SCORE_PREDICTOR.id].includes(parseInt(part.Stage.promotion_type_id))) ? true : false;
											const is_pick_favorite = ([stage_promotion_types.PICK_FAVORITE.id].includes(parseInt(part.Stage.promotion_type_id))) ? true : false;
											const is_bracket_predictor = ([stage_promotion_types.BRACKET_PREDICTOR.id].includes(parseInt(part.Stage.promotion_type_id))) ? true : false;
											return (
												<table key={`participation_${j}`} cellSpacing="0" cellPadding="0" style={{width:'100%'}}>
													<tbody>
														<ParticipationRow
															{...row_props}
															actions={p_actions}
															is_selected={is_selected}
															row_index={p_row_index}
															second_level={true}
															force_counter={(participations.summary.length == 1) ? true : false}
															stageScore={part.Participations[j].User}
														/>
														{(is_selected && !is_team && !is_guess_score && !is_pick_favorite && !is_bracket_predictor) && (
															<tr class="public_quiz_display">
																<td colSpan={total_cols} style={{padding:'0'}}>
																	<QuizStatsPublic 
																		promotion_id={promotion.id} 
																		user_id={participation.User.id} 
																		stage_id={participation.User.stage} />
																</td>
															</tr>
														)}
													</tbody>
												</table>
											);
										})}
									</td>
								</tr>
							);
						}

						return (
							<ParticipationRow
								key={`stage_${i}`}
								{...row_props}
								actions={actions}
								row_index={row_index}
								stageScore={part.StageScore}
							/>
						)
					})}
				</tbody>
			</table>
		</LeveledHTMLText>
	)
};

export default injectIntl(UserParticipationsUnifiedList);